<template>
  <div class="box-table" :style="{height: tableHeight+'px'}">
    <el-table
      ref="seriesTableRefs"
      :data="seriesTable"
      tooltip-effect="dark"
      :max-height="tableHeight"
      :header-cell-style="tableHeader"
      v-loading="loadingSeriesTable"
      element-loading-text="拼命加载中请稍后..."
      element-loading-spinner="el-icon-loading"
      @selection-change="handleSelectionChange"
      @row-click="handleRowClick"
      border
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column show-overflow-tooltip prop="brandName" label="品牌名称">
        <template slot-scope="scope">
          <div class="brand-border line-limit-length">{{ scope.row.brandName }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column show-overflow-tooltip prop="serialGroupName" label="系列组">
        <template slot-scope="scope">
          <div class="approval line-limit-length">{{ scope.row.serialGroupName }}</div>
        </template>
      </el-table-column>-->
      <el-table-column show-overflow-tooltip prop="seriesName" label="系列名称"></el-table-column>
      <el-table-column show-overflow-tooltip prop="seriesNickname" label="系列别称"></el-table-column>
      <el-table-column show-overflow-tooltip prop="mark" label="描述"></el-table-column>
      <el-table-column prop="flag" label="状态">
        <template slot-scope="scope">
          <div class="line-limit-length">{{scope.row.flag?'启用':'停用'}}</div>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="createDate" width="140px" label="添加时间">
        <template slot-scope="scope">{{scope.row.createDate|dateFilter}}</template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="lastDate" width="140px" label="最后更新时间">
        <template slot-scope="scope">{{scope.row.lastDate|dateFilter}}</template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="操作" width="250px">
        <template slot-scope="scope">
          <el-row>
            <el-col :span="5">
              <el-button type="text" @click="onDisable(scope.row)">{{scope.row.flag?'停用':'启用'}}</el-button>
            </el-col>

            <el-col :span="7" v-show="scope.row.flag">
              <el-button type="text" @click="onAddBrandSeries(scope.row)">添加产品</el-button>
            </el-col>
            <el-col :span="5">
              <el-button type="text" @click="onEditBrand(2,scope.row)">编辑</el-button>
            </el-col>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
    <!-------------- 编辑系列 -------------->
    <add-or-edit-series @onRefresh="onUpdateList" ref="addOrEditSeriesRefs"></add-or-edit-series>
    <!-------------- 停用或启用品牌 -------------->
    <open-or-close
      ref="OpenOrCloseRefs"
      @onUpdataState="onUpdataState"
      :title="title"
      :content="content"
    ></open-or-close>
  </div>
</template>

<script>
import { formatDate } from '@/util/tool'
import addOrEditSeries from '../../dialog/addOrEditSeries'
import OpenOrClose from '@/components/OpenOrClose/index'
import { updateBrandSeriesFlagById } from '@/api/product/productManage'
export default {
  props: ['online', 'tab-active', 'seriesTable', 'loadingSeriesTable'],
  components: {
    'open-or-close': OpenOrClose,
    'add-or-edit-series': addOrEditSeries
  },
  name: 'BrandSeriesTable',
  data () {
    return {
      currentPage: 1,
      size: 20,
      addBrandSeriesDialog: false, // 添加系列
      title: '',
      content: '',
      checkList: [], // 选择的列表数据
      tableHeight: window.innerHeight - 380

    }
  },
  created () { },
  methods: {
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 停用和启用
    onDisable (row) {
      if (!row.flag) {
        this.title = '启用'
        this.content = '确定启用该系列？'
      } else {
        this.content = '确定停用该系列？'
        this.title = '停用'
      }
      this.$refs.OpenOrCloseRefs.onInitial(row)
    },
    // 确认停用启用
    onUpdataState (params) {
      updateBrandSeriesFlagById(params.id, !params.flag)
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success(
              params.flag ? '该系列已停用！' : '该系列已启用'
            )
            this.$emit('onRefresh')
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 编辑系列
    onEditBrand (type, row) {
      this.$refs.addOrEditSeriesRefs.onInitialize(type, row)
    },
    // 刷新父级获取列表的接口
    onUpdateList () {
      this.$emit('onRefresh')
    },
    // 添加系列
    onAddBrandSeries (row) {
      this.$router.push({
        path: '/product/productManage/addProduct',
        query: {
          brandId: row.brandId,
          seriesId: row.id
        }
      })
    },
    // 设置系数
    onCoefficient () {
      this.$router.push({
        name: 'coefficientAdjustment',
        params: { goTo: 'seriesCoefficient' }
      })
    },
    // 列表数据选中
    handleSelectionChange (row) {
      this.checkList = row
    },
    // 点击空白处选中
    handleRowClick (row, column, event) {
      this.$refs.seriesTableRefs.toggleRowSelection(row)
    }
  },
  filters: {
    dateFilter
  }
}
function dateFilter (time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
</script>
